var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VizCompBars',{staticClass:"metric",attrs:{"barData":_vm.barData,"rowLabelWidth":_vm.rowLabelWidth,"rangeMax":_vm.barMax,"valFormat":_vm.valFormat,"legend":_vm.legendText}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ebc53c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sqs/2019/tab-mods/MetricVizCompBars.vue
// module id = null
// module chunks = 